import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Container, Divider, Stack } from '@fiverr-private/layout_components';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { List, ListItem, ListItemIcon } from '@fiverr-private/list';
import { CheckIcon } from '@fiverr-private/visuals';
import { Button } from '@fiverr-private/button';
import { Domingo } from '@fiverr-private/domingo';
import { getContext } from '@fiverr-private/fiverr_context';
import { ElementType } from '@fiverr-private/bianka_js';
import hasTranslation from '@fiverr-private/i18n-react/src/hasTranslation';
import { reportClick } from '../../utils/biEvents/events/biankaEvents';
import { sendMixPanelEvent } from '../../utils/biEvents';
import { MP_FIVERR_PRO_PACKAGE_CLICKED } from '../../utils/biEvents/events/mixPanelEvents';
import { packageSubtitleClass } from './styles.ve.css';

const COPY_KEY_PREFIX = 'logged_out_homepage.pro_packages_banner.fiverr_pro_package';
const FIVERR_PRO_BENEFITS_COUNT = 4;

export const FiverrProPackage = () => {
    const { url } = getContext();
    const redirectToProUrl = `${Domingo(url).removePath().pro().url}?source=LOHP_business_banner&modal=join`;
    const benefits = Array.from(Array(FIVERR_PRO_BENEFITS_COUNT).keys()).filter((index) =>
        hasTranslation(`${COPY_KEY_PREFIX}.benefits.${index + 1}`)
    );
    const joinFiverrProClick = () => {
        reportClick({
            eventName: 'clicked_on_fiverr_enterprise_learn_more',
            elementName: 'fiverr_enterprise_learn_more',
            elementType: ElementType.LINK,
        });
        sendMixPanelEvent({ eventName: MP_FIVERR_PRO_PACKAGE_CLICKED });
    };

    return (
        <Stack
            position="relative"
            direction="column"
            justifyContent="spaceBetween"
            gap="0"
            paddingX="6"
            paddingY="9"
            borderRadius="xl"
            overflow="hidden"
            boxShadow="z2"
            flexGrow="1"
            flexBasis="350px"
            backgroundColor="white"
            minWidth={{ default: 'auto', lg: '320px', xl: '350px' }}
        >
            <Container position="absolute" top={0} left={0} backgroundColor="green_700" height="8px" width="100%" />
            <Stack direction="column" gap="0">
                <Heading as="h4" size="h_sm" fontWeight="bold">
                    <I18n k={`${COPY_KEY_PREFIX}.title`} />
                </Heading>
                <Text
                    marginTop="2"
                    className={packageSubtitleClass}
                    size={{
                        default: 'b_sm',
                        md: 'b_md',
                    }}
                >
                    <I18n k={`${COPY_KEY_PREFIX}.subtitle`} />
                </Text>
                <Divider marginY="4" />
                <Typography color="grey_1000" fontWeight="semibold" size="b_sm">
                    <I18n k={`${COPY_KEY_PREFIX}.everything_plus`} />
                </Typography>
                <List marginTop="4" paddingLeft="0">
                    {benefits.map((index) => (
                        <ListItem key={index}>
                            <ListItemIcon>
                                <CheckIcon size="md" color="green_700" />
                            </ListItemIcon>
                            <Typography size="b_sm" color="grey_1100">
                                <I18n k={`${COPY_KEY_PREFIX}.benefits.${index + 1}`} />
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Stack>
            <Stack direction="column" gap="0" marginTop="8">
                <Button href={redirectToProUrl} onClick={joinFiverrProClick}>
                    <I18n k={`${COPY_KEY_PREFIX}.join_fiverr_pro`} />
                </Button>
                <Typography
                    size="b_sm"
                    color="grey_1100"
                    fontWeight="semibold"
                    marginTop="6"
                    textAlign="center"
                    height={{
                        default: 'auto',
                        lg: '44px',
                        xl: 'auto',
                    }}
                >
                    <I18n k={`${COPY_KEY_PREFIX}.free_one_year`} />
                </Typography>
            </Stack>
        </Stack>
    );
};
